import React from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { CoreLink } from '@uncinc/react-drupal-core';
import c from 'classnames';

import { DEFAULT_LANGUAGE } from '../../config/constants';

import './style.scss';

const Breadcrumbs = (props) => {
  const { includeCurrent, overrideUrl, overrideTitle } = props;

  const breadcrumbs = useSelector((state) => {
    const entityBreadcrumbs = state.getIn(['entity', 'breadcrumbs']);
    if (entityBreadcrumbs.count() !== 0 && (!overrideUrl && !overrideTitle)) {
      return state.getIn(['entity', 'breadcrumbs']);
    }

    // Add custom breadcrumbs if entity does not have breadcrumbs.
    const breadcrumbs = [{
      title: 'home',
      url: '/nl',
    }];
    if (overrideUrl && overrideTitle) {
      breadcrumbs.push({
        title: overrideTitle,
        url: overrideUrl,
      });
    }
    return Immutable.fromJS(breadcrumbs);
  });
  const { currentTitle, currentUrl } = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const entityType = state.getIn(['entity', 'entityType']);

    let entity = state.getIn([entityType, entityId]);
    if (entityType === 'taxonomy_term') {
      entity = state.getIn(['taxonomyTerm', entityId]);
    }
    if (!entity) {
      if (overrideTitle) {
        return { currentTitle: overrideTitle, currentUrl: overrideUrl };
      }
      return { currentTitle: null, currentUrl: null };
    }

    let title = entity.getIn(['title', 0, 'value']);
    if (entityType === 'taxonomy_term') {
      title = entity.getIn(['name', 0, 'value']);
    }

    const url = entity.getIn(['paths', DEFAULT_LANGUAGE]);
    return { currentTitle: title, currentUrl: url };
  });


  let breadcrumbItems = breadcrumbs.map((item, index) => {
    const url = item.get('url');
    let breadcrumbTitle = item.get('title');
    const classes = c('Breadcrumbs__item__link', {
      'icon-before icon--home icon-variant-1': index === 0,
    });

    if (typeof breadcrumbTitle === 'object') {
      breadcrumbTitle = breadcrumbTitle.get('#markup');
    }

    if (includeCurrent && currentTitle && currentUrl) {
      if (currentTitle === breadcrumbTitle) {
        return;
      }
    }

    return (
      <li key={url} className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
        <CoreLink property="item" typeof="WebPage" className={classes} to={url}><span>{breadcrumbTitle}</span></CoreLink>
        <meta property="position" content={index} />
      </li>
    );
  });

  if (includeCurrent && currentTitle && currentUrl) {
    const index = breadcrumbItems.size + 1;

    breadcrumbItems = breadcrumbItems.push(
      <li key={currentUrl} className="Breadcrumbs__item" property="itemListElement" typeof="ListItem">
        <CoreLink property="item" typeof="WebPage" to={currentUrl}><span>{currentTitle}</span></CoreLink>
        <meta property="position" content={index} />
      </li>,
    );
  }

  return (
    <ol className="Breadcrumbs" vocab="https://schema.org/" typeof="BreadcrumbList">
      {breadcrumbItems}
    </ol>
  );
};

export default Breadcrumbs;
